import { webappsApi } from '@/infrastructure/Configuration'

export default class SmartLinkingService {
  constructor(httpClient) {
    this.httpClient = httpClient
  }

  async getDealsBanners() {
    const url = `${webappsApi}/smart-linking-banners`

    try {
      const res = await this.httpClient.get(url, {
        headers: { Accept: 'application/json' }
      })
      const dealsSection = res.data?.smartlinking?.find(item => item.section === 'DEALS')

      return (
        dealsSection?.banner || {
          logged: null,
          nonLogged: null
        }
      )
    } catch (e) {
      console.error('SmartLinkingService:getDealsBanners error', e)

      return {
        logged: null,
        nonLogged: null
      }
    }
  }

  async getModalSmartLinkingImage() {
    const { data } = await this.httpClient.get(`${webappsApi}/configs`)

    return {
      rhg: data?.modalSmartLinkingRedirectionRHG,
      lhg: data?.modalSmartLinkingRedirectionLHG
    }
  }
}
